<template>
  <v-row justify="center">
  
    <v-dialog
      v-model="show"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Registrar</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Email*"
                  v-model="email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Password*"
                  type="password"
                  v-model="password"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="register"
            :loading="loading"
          >
            Log In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { EventBus } from '@/utils'
import router from '../router'
 export default {
   data(){
    return {
        show: true,
        password:"",
        email:"",
        loading: false
    }
   },
   watch:{
      show:function(newValue){
      if(!newValue){
        this.closeDialog()
      }
    },
    },

   mounted () {
    EventBus.$on('failedRegistering', (msg) => {
      this.errorMsg = msg
      })
    EventBus.$on('failedAuthentication', (msg) => {
    this.errorMsg = msg
      })
    },

    methods: {
      posibleCloseDialog(event){console.log(event)},
      closeDialog(){
          this.$emit('closeDialog', 'register')
      },
      register () {
        this.loading = true
        this.$store.dispatch('register', { email: this.email, password: this.password })
        .then((response) => {
          if (response.status == 201) this.closeDialog()
          if (this.$store.getters.isAuthenticated) router.push({ name: 'FloidView' })
          this.loading = false
        })
      },
      authenticate () {
        this.$store.dispatch('login', { email: this.email, password: this.password })
        .then((response) => {
          console.log(response)
          if (this.$store.getters.isAuthenticated)this.closeDialog()
        })
      },
    },
    
    beforeDestroy () {
      EventBus.$off('failedRegistering')
      EventBus.$off('failedAuthentication')
    }
 }
</script>